<template>
  <Tab no-help @close="removeCurrent">
    <template #toolbar-items>
      <!-- ------------------------ list ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'list'"
        icon="fa-list"
        name="list"
      ></TabToolbarButton>
      <!-- ------------------------ create ------------------------ -->
      <TabToolbarButton
        v-if="isNewStory"
        v-model="page"
        :menu="menu"
        :selected="page === 'create'"
        icon="fa-book-medical"
        name="create"
      ></TabToolbarButton>
    </template>
    <template #container>
      <!-- ------------------------ list ------------------------ -->
      <TabPage :menu="menu" :page="page" name="list" no-documentation>
        <template #content>
          <v-row>
            <v-col cols="12">
              <v-stepper v-model="step" class="elevation-0">
                <v-stepper-items>
                  <!-- Step render story -->
                  <v-stepper-content :step="1" class="pa-0">
                    <template>
                      <v-row>
                        <!-- List of reviews -->
                        <v-col cols="4">
                          <v-card>
                            <v-container style="overflow: hidden;">
                              <span class="sr-title">
                                <!-- List title -->
                                {{ $t("stories.me.list.title") }}
                              </span>
                              <div class="float-right" style="position:relative; top:-5px;">
                                <v-btn :title="$t('stories.manager.list.reload')" color="primary" icon @click="fetchStories()">
                                  <v-icon small>fas fa-sync-alt</v-icon>
                                </v-btn>
                              </div>
                            </v-container>
                            <v-card-text v-if="stories.length > 0" class="pa-0">
                              <v-list subheader two-line>
                                <!-- Scrollable list of stories -->
                                <v-list-item-group
                                  v-model="selectedStory"
                                  active-class="blue--text"
                                  style="height: calc(100vh - 250px);overflow-y: auto;"
                                >
                                  <v-list-item
                                    v-for="storyItem in stories"
                                    :key="storyItem.id + storyItem.database"
                                    class="tw-border"
                                    color="primary"
                                    three-line
                                  >
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        <a
                                          :title="$t('stories.me.list.host')"
                                          class="mr-1"
                                          x-small
                                          @click="openPageWhereStoryHasBeenPosted(storyItem.full_path)"
                                        >
                                          <v-icon color="black" left x-small>
                                            fa-globe
                                          </v-icon>
                                          {{ storyItem.host }}
                                        </a>
                                        <v-chip :title="$t('stories.me.list.likes_counter')" class="mr-1" x-small>
                                          <v-icon color="blue" left x-small>
                                            fa-thumbs-up
                                          </v-icon>
                                          {{ storyItem.likes_counter }}
                                        </v-chip>
                                      </v-list-item-title>

                                      <v-list-item-subtitle
                                        v-if="storyItem.content.hasOwnProperty('html')"
                                        class="mt-3 mb-3"
                                      >
                                        {{ renderStoryHtmlToText(storyItem.content.html) }}
                                      </v-list-item-subtitle>
                                      <v-list-item-title>
                                        <template>
                                          <v-chip
                                            v-if="storyItem.is_moderate === true && storyItem.confidence >= 40"
                                            :title="$t('stories.me.list.moderation')"
                                            class="mr-1 white--text"
                                            color="green"
                                            x-small
                                          >
                                            <v-icon left x-small>
                                              fa-user-check
                                            </v-icon>
                                            {{ $t("stories.me.list.published") }}
                                          </v-chip>
                                          <v-chip
                                            v-else-if="storyItem.is_moderate === true && storyItem.confidence <= 10"
                                            :title="$t('stories.me.list.moderation')"
                                            class="mr-1 white--text"
                                            color="red"
                                            x-small
                                          >
                                            <v-icon left x-small>
                                              fa-user-check
                                            </v-icon>
                                            {{ $t("stories.me.list.rejected") }}
                                          </v-chip>
                                          <v-chip
                                            v-else
                                            :title="$t('stories.me.list.moderation')"
                                            class="mr-1 white--text"
                                            color="blue"
                                            x-small
                                          >
                                            <v-icon left x-small>
                                              fa-user-check
                                            </v-icon>
                                            {{ $t("stories.me.list.waiting") }}
                                          </v-chip>
                                        </template>
                                        <v-chip :title="$t('stories.me.list.created_at')" class="mr-1" x-small>
                                          <v-icon color="black" left x-small>fa-history</v-icon>
                                          {{ storyItem.created_at | moment("from") }}
                                        </v-chip>
                                      </v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                            </v-card-text>
                            <v-card-text v-else>
                              {{ $t("stories.me.list.nothing") }}
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <!-- One Selected review -->
                        <v-col v-if="story" cols="8">
                          <v-row v-if="story.content.hasOwnProperty('render')">
                            <v-col cols="8" style="max-height: calc(100vh - 96px);">
                              <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.render") }}</div>
                              <div
                                class="sr-story-render"
                                style="max-height: calc(100vh - 160px);"
                                v-html="story.content.render"
                              ></div>
                            </v-col>
                            <v-col cols="4">
                              <v-card-actions class="ml-2 mt-3">
                                <v-btn color="primary" small @click="step = 2">
                                  {{ $t("stories.me.render.edit") }}
                                </v-btn>
                              </v-card-actions>

                              <v-card-text v-if="story.is_moderate === true" class="mt-3">
                                <v-alert v-if="story.confidence <= 10" border="left" color="red" type="warning">
                                  <i>{{ $t("stories.me.render.rejected") }}</i>
                                  <br />
                                  <i>{{ $t("stories.me.render.reason") }} : {{ reasons[story.confidence - 1].text }}</i>
                                </v-alert>
                                <v-alert v-else border="left" color="green" type="success">
                                  <i>{{ $t("stories.me.render.published") }}</i>
                                </v-alert>
                              </v-card-text>
                            </v-col>
                          </v-row>
                        </v-col>
                        <!-- No Selected review show Help-->
                        <v-col v-else cols="8">
                          <v-row>
                            <v-col>
                              <DocumentationDiv path="me/stories/list" :key="$i18n.locale"/>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>
                  </v-stepper-content>

                  <!-- Step modify story -->
                  <v-stepper-content :step="2" class="pa-0">
                    <v-card v-if="story" class="mx-auto">
                      <v-row>
                        <v-col cols="12" sm="6" style="max-height: calc(100vh - 100px);">
                          <v-card-text class="mx-auto" style="max-height: calc(100vh - 180px);overflow-y: auto;">
                            <template v-if="story.host">
                              <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.url") }}</div>
                              <v-text-field v-model="story.host" disabled />
                            </template>
                            <template v-if="story.content.hasOwnProperty('template')">
                              <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.template") }}</div>
                              <v-select v-model="editorTemplate" :items="editorTemplates"></v-select>
                            </template>
                            <template v-if="story.content.hasOwnProperty('image')">
                              <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.image") }}</div>
                              <!--                          <v-text-field v-model="story.content.image" readonly solo></v-text-field>-->
                              <v-file-input v-model="editorImageFile" :clearable="false" show-size />
                            </template>
                            <template v-if="story.content.hasOwnProperty('html')">
                              <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.html") }}</div>
                              <ckeditor
                                v-model="editorContent"
                                :config="editorConfig"
                                :editor="editor"
                                @input="renderStory"
                              ></ckeditor>
                            </template>
                          </v-card-text>
                          <v-card-actions class="mx-auto mt-2">
                            <v-btn class="mr-1" color="primary" small @click="saveStoryModifications"
                              >{{ $t("stories.me.editor.save") }}
                            </v-btn>
                            <v-btn color="default" small @click="cancelStoryModifications"
                              >{{ $t("stories.me.editor.cancel") }}
                            </v-btn>
                          </v-card-actions>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <template v-if="story.content.hasOwnProperty('render')">
                            <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.render") }}</div>
                            <div
                              class="sr-story-render"
                              style="max-height: calc(100vh - 160px);"
                              v-html="story.content.render"
                            ></div>
                          </template>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-col>
          </v-row>
        </template>
      </TabPage>

      <!-- ------------------------ create ------------------------ -->
      <TabPage :menu="menu" :page="page" name="create" no-documentation>
        <template #content>
          <v-row v-if="story">
            <v-col cols="12" sm="6" style="max-height: calc(100vh - 100px);">
              <v-card class="mx-auto" style="max-height: calc(100vh - 160px);overflow-y: auto;">
                <v-container>
                  <span class="sr-title">
                    <!-- List title -->
                    {{ $t("stories.create.title") }}
                  </span>
                </v-container>
                <v-card-text>
                  <template v-if="context">
                    <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.url") }}</div>
                    <v-text-field v-model="context" disabled />
                  </template>

                  <template v-if="story.content.hasOwnProperty('template')">
                    <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.template") }}</div>
                    <v-select v-model="editorTemplate" :items="editorTemplates"></v-select>
                  </template>

                  <template v-if="story.content.hasOwnProperty('image')">
                    <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.image") }}</div>
                    <v-file-input v-model="editorImageFile" :clearable="false" show-size />
                  </template>

                  <template v-if="story.content.hasOwnProperty('html')">
                    <div class="me-editor tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.html") }}</div>
                    <ckeditor
                      v-model="editorContent"
                      :config="editorConfig"
                      :editor="editor"
                      @input="renderStory"
                    ></ckeditor>
                  </template>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto mt-1">
                <v-card-actions>
                  <v-btn class="mr-1" color="primary" small @click="createStory">
                    {{ $t("stories.create.save") }}
                  </v-btn>
                  <v-btn color="default" small @click="cancelStoryCreation">{{ $t("stories.create.cancel") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card class="mx-auto">
                <template v-if="story.content.hasOwnProperty('render')">
                  <v-col col="6" style="max-height: calc(100vh - 100px);">
                    <div class="tw-mb-2 tw-font-semibold">{{ $t("stories.me.editor.render") }}</div>
                    <div
                      class="sr-story-render"
                      style="max-height: calc(100vh - 160px);"
                      v-html="story.content.render"
                    ></div>
                  </v-col>
                </template>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </TabPage>
    </template>
  </Tab>
</template>
<script>
import tab from "../../../../mixins/tab"
import stories from "../../../../mixins/stories"
import ClassicEditor from "ckeditor5-build-custom"
import { Types as TypesSnackbar } from "../../../../store/modules/snackbar"
import {Types as TypesLoading} from "@/store/modules/loading";

export default {
  name: "Stories",
  mixins: [tab, stories],
  data: () => ({
    pages: ["list", "create"],
    menu: "stories",
    page: "list",
    step: 1,
    story: null,
    selectedStory: null,
    stories: [],
    editorImageFile: null,
    editorImageBackupLink: null,
    editorMode: false,
    editor: ClassicEditor,
    editorContent: "",
    editorConfig: {
      language: "fr",
      toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "|",
        "alignment",
        "|",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "link",
        "|",
        "bulletedList",
        "numberedList",
      ],
    },
    editorTemplates: [
      { value: "photo-first", text: "L'image puis le texte" },
      { value: "text-first", text: "Le texte puis l'image" },
      { value: "text-over-image", text: "Le texte sur l'image" },
    ],
    editorTemplate: "photo-first",
    context: null,
  }),
  mounted() {
    const context = this.$route.query.context
    let isValidContext = false

    try {
      let url = new URL(context)
      if (["http:", "https:"].includes(url.protocol)) {
        isValidContext = true
        this.context = context
      }
    } catch (_) {
      isValidContext = false
    }

    if (this.isNewStory && context && isValidContext) {
      this.fillEmptyStory()
      this.page = "create"
      this.renderStory()
    }

    this.fetchStories()

    this.reasons = [
      {
        value: 1,
        text: this.$t("stories.me.response.report.1"),
      },
      {
        value: 2,
        text: this.$t("stories.me.response.report.2"),
      },
      {
        value: 3,
        text: this.$t("stories.me.response.report.3"),
      },
      {
        value: 4,
        text: this.$t("stories.me.response.report.4"),
      },
      {
        value: 5,
        text: this.$t("stories.me.response.report.5"),
      },
      {
        value: 6,
        text: this.$t("stories.me.response.report.6"),
      },
      {
        value: 7,
        text: this.$t("stories.me.response.report.7"),
      },
      {
        value: 8,
        text: this.$t("stories.me.response.report.8"),
      },
      {
        value: 9,
        text: this.$t("stories.me.response.report.9"),
      },
    ]
  },
  watch: {
    selectedStory(value) {
      if (value !== undefined) {
        this.resetSteppers()
        this.story = this.stories[value]
        this.editorContent = this.story.content.html
        this.renderStory()
      } else {
        this.story = null
      }
    },
    editorTemplate(value) {
      this.story.content.template = value
      this.renderStory()
      this.refreshStoriesList()
    },
    editorImageFile(file) {
      if (file === null || file === undefined) {
        return
      }

      if (["png", "jpeg", "jpg", "bmp", "gif", "webp", "tiff", "tif"].some(ext => file.name.endsWith(ext))) {
        this.editorImageBackupLink = this.story.content.image
        this.story.content.image = URL.createObjectURL(file)
        this.renderStory()
      }
    },
    editorContent() {
      this.renderStory()
      this.refreshStoriesList()
    },
  },
  computed: {
    isNewStory() {
      return this.$route.query.init && this.$route.query.init === "new_story"
    },
    updateDate() {
      return this.$moment(this.story.updated_at).from()
    },
    pertinenceColor() {
      switch (this.pertinence) {
        case 1:
          return "red darken-3"
        case 2:
          return "red"
        case 3:
          return "orange darken-3"
        case 4:
          return "orange"
        case 5:
          return "orange lighten-2"
        case 6:
          return "green darken-3"
        case 7:
          return "green darken-1"
        case 8:
          return "green"
        case 9:
          return "green lighten-2"
        default:
          return "grey"
      }
    },
  },
  methods: {
    async createStory() {
      try {
        if (this.editorImageFile !== null) {
          let formData = new FormData()
          formData.append("file_1", this.editorImageFile)
          formData.append("virtual_path", "me/story/image")

          let response = await this.$axios.post("cdn/static/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          this.story.content.image = response.data.data[0].url

          this.renderStory()
          this.clearImageFile()
        }

        this.story.content.html = this.editorContent
        let story = { ...this.story }
        story.content = JSON.stringify(story.content)
        story.context = this.context

        await this.$axios.post("office/me/story", story)
        this.fetchStories()
        this.page = "list"
      } catch (e) {
        this.handleError("stories.me.error.post_story")
      }
    },
    fillEmptyStory() {
      this.story = {
        content: { image: "", template: "top", render: "", html: "" },
      }
      this.story.content.template = this.editorTemplate
      this.story.content.image = this.$t("stories.me.empty.image_url")
      this.story.content.html =
        "<h2>" + this.$t("stories.me.empty.title") + "</h2>" + "<p>" + this.$t("stories.me.empty.content") + "</p>"
      this.editorContent = this.story.content.html
      this.clearImageFile()
    },
    cancelStoryCreation() {
      this.story = {
        content: { image: "", template: "top", render: "", html: "" },
      }
      this.editorContent = ""
      this.clearImageFile()
    },
    refreshStoriesList() {
      this.stories[this.selectedStory] = this.story
    },
    resetSteppers() {
      this.step = 1
    },
    async saveStoryModifications() {
      try {
        if (this.editorImageFile !== null) {
          let formData = new FormData()
          formData.append("file_1", this.editorImageFile)
          formData.append("virtual_path", "me/story/image")

          let response = await this.$axios.post("cdn/static/image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          this.story.content.image = response.data.data[0].url

          this.renderStory()
          this.clearImageFile()
        }

        this.story.content.html = this.editorContent
        let story = { ...this.story }
        story.content = JSON.stringify(story.content)

        await this.$axios.patch("office/me/story", story)
        this.step = 1
      } catch (e) {
        this.handleError("stories.me.error.patch_story")
      }
    },
    cancelStoryModifications() {
      this.clearImageFile()
      this.editorContent = this.story.content.html
      this.resetSteppers()
      this.renderStory()
    },
    clearImageFile() {
      if (this.story.content.image.startsWith("blob:")) {
        URL.revokeObjectURL(this.story.content.image)
        this.story.content.image = this.editorImageBackupLink
      }

      this.editorImageBackupLink = null
      this.editorImageFile = null
    },
    handleError(i18n = "") {
      this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
        lines: this.$t(i18n),
        config: { timeout: 1000 * 6, color: "error" },
      })
    },
    fetchStories() {
      this.$store.commit(TypesLoading.mutations.LOADING_YES)
      this.stories = []
      this.$axios
        .get("office/me/stories")
        .then(response => {
          this.stories = response.data.reduce((accumulator, story) => {
            story.content = JSON.parse(story.content)
            accumulator.push(story)
            return accumulator
          }, [])
        })
        .catch(() => this.handleError("stories.me.error.fetch_stories"))
        .finally(() => this.$store.commit(TypesLoading.mutations.LOADING_NO))
    },
    openPageWhereStoryHasBeenPosted(url) {
      window.open(url, "_blank")
    },
  },
}
</script>
